import React from "react";
import {ImageObject, LandingPagePayload} from "../contenful/types";
import Content from "./Content";
import Page from "../layout/Page";
import Root from "../layout/Root";
import './styles/LandingPageComponent.scss';
import DynamicContentView from "./pagesection/DynamicContentView";
import {Settings} from "../http/protocol";
import PromotionArea from "./PromotionArea";
import BottomSection from "./BottomSection";
import BundlesLandingPage from "../storepage/BundlesLandingPage";


interface Props {
    landingpage: LandingPagePayload;
    imgSrc?: {url?:string, width?:number, height?:number};
    innerImgSrc?: {url?:string};
    settings?: Settings;
    loggedIn: boolean;
    pathPush?: string;
}
interface ImageType  { url? : string, width?: string, height? : string }

const LandingPageComponent: React.FC<Props> = ({loggedIn, landingpage, settings,pathPush}) => {
    const position = landingpage.bannerContentPosition && landingpage.bannerContentPosition[0]
    const signupForm = landingpage.bannerSignupForm
    let className = "ContentWrapper";
    if((position === 'right' || position === 'left') && signupForm) {
        className += " twoColumns"
    } else if (position === 'left' && !signupForm) {
        className += " contentLeft"
    } else if (position === 'right' && !signupForm) {
        className += " contentRight"
    }
    const toImage = (img : ImageObject) => {
        return {
            url: img?.fields?.file?.url,
            width:img?.fields?.file?.details?.image?.width,
            height: img?.fields?.file?.details?.image?.height
        };
    }

    let imgSrc:ImageType = {};
    let innerImgSrc: ImageType = {}
    if(landingpage?.backgroundImage?.fields?.file?.url) {
        imgSrc = toImage(landingpage?.backgroundImage);
    }
    if(landingpage?.innerImage?.fields?.file?.url) {
        innerImgSrc = toImage(landingpage?.innerImage)
    }

    return (
        <Root footer={true}>
            <Page>
                { (landingpage.content1 || imgSrc?.url || innerImgSrc?.url) && (
                    <div className={"landingPageContainer"}>
                        {imgSrc && <img alt="head background image" className={`hero-bg`} src={imgSrc.url+"?fm=webp"} width={imgSrc.width} height={imgSrc.height}/>}
                        {innerImgSrc && innerImgSrc.url &&
                        <div className="imageInnerContainer">
                            <img src={innerImgSrc.url+"?fm=webp"} className={`imageInner`} alt={`imageInner`} />
                        </div>}

                        {landingpage.content1 && (
                            <div className={"landingPageContent"}>
                                <div className={className}>
                                    <Content
                                        loggedIn={loggedIn}
                                        content1={landingpage.content1}
                                        content2={landingpage.content2}
                                        buttonTitle={landingpage.buttonTitle}
                                        position={position}
                                        signupForm={signupForm}
                                        pathPush={pathPush}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <DynamicContentView dynamicContent={landingpage.dynamicContent} loggedIn={loggedIn}/>
                {
                    settings&& settings.useStoreInsteadOfDeposit
                        ? <BundlesLandingPage />
                        : null
                }
                <BottomSection loggedIn={loggedIn} landingpage={landingpage} classList="landingBottomSection" />
                {
                    landingpage.promotionArea&& (
                        <PromotionArea landingpage={landingpage} />
                    )
                }
            </Page>
        </Root>
    )
}

export default LandingPageComponent;

